import { DataEntry } from '../../../lib/types';
import { getCourses } from '../../../modules/course/api';
import { Course, CourseState } from '../../../modules/course/types';

export const getCoursesUseCase = async (courseState: CourseState): Promise<DataEntry<Course>[]> => {
  return getCourses(courseState);
};